import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from 'lane-shared/types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

export type OutlookCalendarSettingsType = {
  clientId: string;
  clientSecret: string;
  tenantId: string;
};

const OutlookCalendarDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.OutlookCalendar,
  hasCustomUI: false,
  friendlyName: 'Outlook Calendar',
  description:
    'Defines the properties required for an integration with Outlook Calendar.',
  category: IntegrationCategoryEnum.RoomBooking,
  platforms: [PlatformEnum.Mobile, PlatformEnum.Web],
  type: IntegrationTypeEnum.Api,
  settings: {},
  properties: {
    clientId: {
      friendlyName: 'Application ID',
      description: 'ID of a registered application in Azure Active Directory',
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: '',
        },
      ],
    },
    clientSecret: {
      friendlyName: 'Secret for the client app',
      description: 'Secret key generated for the registered application',
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: '',
        },
      ],
    },
    tenantId: {
      friendlyName: 'Tenant ID',
      description: 'Tenant ID in Azure Active Directory',
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: '',
        },
      ],
    },
  },
};

/**
 * @deprecated Use `OutlookCalendarDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { OutlookCalendarDefinition } from 'application-types';`
 */
export default OutlookCalendarDefinition;
